<template>
<b-form>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>          
            <ECMConnectionModal v-model="showECMConnectionModal" :existingNames="paramSets" ref="ecmConnectionModal" /> 
            <RDBMSConnectionStrings v-model="showRDBMSConnectionStrings" ref="rdbmsConnectionStrings" /> 
            
            <ECMConfirmDialog ref="confirmationDlg" v-model="confirmationDlg"/>
        </b-row>
    </b-col>
</b-row>
        <b-row>
            <b-col>
                <otif-textInput
                    v-bind:label="ecmResourceStrings.lblDescription"
                    v-model="description"
                    :description="ecmResourceStrings.tipRDBMSDescription"/>
                <ecmconnection-select
                    v-model="$v.selectedDriverSet"
                    v-bind:label="ecmResourceStrings.lblDriver"
                    :parameters="driversSets"
                    :selectedSet="selectedDriverSet"
                    ref="driver_selector"
                    @reselected="reselected"
                    :description="ecmResourceStrings.txtDatabaseDriver"/>
                <otif-textarea
                    v-model="connectionString"
                    v-bind:label="ecmResourceStrings.lblConnectionString"
                    :description="ecmResourceStrings.txtConnectionString" 
                    />
                <otif-textInput
                    v-bind:label="ecmResourceStrings.lblSchemaName"
                    v-model="schemaName"
                    :description="ecmResourceStrings.txtSchemaName" />
                <otif-textInput
                    v-bind:label="ecmResourceStrings.lblInitCommand"
                    v-model="initCommand"
                    :description="ecmResourceStrings.txtInitCommand"/>
                <otif-textInput
                    v-bind:label="ecmResourceStrings.lblUserName"
                    v-model="username"
                    :description="ecmResourceStrings.tipDBUserName"/>
                <otif-passwordInput
                    v-model="password"
                    v-bind:label="ecmResourceStrings.lblPassword"
                    :description="ecmResourceStrings.tipDBPassword"/>
            </b-col>
        </b-row>
      </b-form>
</template>

<script>

import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { numericval } from '../../../utils/validatorECM.js';
import { showMessage } from '../../../utils/commonECM.js';
import OtifGlobalActions from '../../../../../../mtm-studio-components/src/components/table/GlobalActions.vue';
import SettingsTable from '@/ecm/components/ECMParametersTable.vue';
import EcmRepositoryConnections from '../../../../ecm/components/widgets/ECMRepositoryConnections.vue';
import ECMConnectionModal from '../../modals/ECMCreateConnection.vue';
import RDBMSConnectionStrings from '../../modals/RDBMSConnectionStrings.vue';
import ECMConfirmDialog from '../../modals/ECMCrawlerConfirmDlg.vue';
import { showConfirmationDialog } from '../../../utils/commonECM.js';
import StatusColumn from '../../links/ecmmandatorystatus.vue';
import { connectionsettings } from '../../../utils/validatorECM.js';

const defaultTemplates = {
    '2':'DRIVER={OpenText 8.0 SQL Server Wire Protocol};HOST=;PORT=1433;DB=;WorkArounds2=2;TimestampTruncationBehavior=1',
    '3':'DRIVER={OpenText 8.0 Oracle Wire Protocol};HOST=;PORT=1521;ServiceName=;WorkArounds2=2;TimestampTruncationBehavior=1',
    '1':'DRIVER={DataDirect 7.1 PostgreSQL Wire Protocol};HOST=;PORT=5432;DB=;WorkArounds2=2;TimestampTruncationBehavior=1;IANAAppCodePage=106',
    '0':'',
};

export default {

    props: ['selectedECMType', 'ecmRepository', 'parametersFromGrammar', 'realParametersConfigurations' , 'availableParametersConfigurations'],
    
    components: {
        ECMErrorDialog,
        OtifGlobalActions,
        SettingsTable,
        ECMConnectionModal,
        RDBMSConnectionStrings,
        'ecmconnection-select': EcmRepositoryConnections,
        ECMConfirmDialog,
    },
    mixins: [ validationMixin ],

    data() {
        return { 
            username: '',
            description:'',
            password: '',
            connectionString:'',
            initCommand:'',
            schemaName:'',
            paramSets : [],//set of connections
            selectedSet:'0',
            selectedName:'',
            selectedParameters:[],
            fullPackage : [],
            driversSets : [
                    {description: 'Default', index: '0'},
                    {description: 'PostgreSQL', index: '1'},
                    {description: 'SQL', index: '2'},
                    {description: 'Oracle', index: '3'}
                ],
           
            selectedDriverSet:'0',
            
            lastexistingindex:-1,// see note

            loaded: false,
            messageDlg: false,
            confirmationDlg:false,
            showECMConnectionModal: false,
            showRDBMSConnectionStrings:false,
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            
            customOptions:  [],
            globalActions: [{
                    name: 'add',
                    label: 'Add Connection',
                    callback: () => { this.addConnection(); }
                },
                {
                    name: 'delete',
                    label: 'Delete Connection',
                    callback: () => { this.deleteConnection(); }
            }],
            columns:[{
                name: 'name',
                label: 'Name',
                sortable: false,
                editable:false,
                render(row) {
                    return row.name;
                }
            },{
                name: 'type',
                label: 'Type',
                sortable: false,
                editable:false,
                render(row) {
                    return row.type;
                }
            },{
                name: 'status',
                label: '',
                sortable: false,
                editable:false,
                displayComponent:StatusColumn,
                
            },{
                name: 'value',
                label: 'Value',
                sortable: false,
                editable:true,
                render(row) {
                    return row.value;
                }
            }],
            tableValidations: {
                name:{},
                type:{},
                value: { 
                    connectionsettings
                },
                status:{},
            },
        }
    },

    validations: {
        form: {

        }
    },

    computed: {
        connections(){
            return paramSets;
        }
    },

     watch: {
        username(newval) {
            this.updateelement('username',newval);
        },
        password(newval){
            this.updateelement('password',newval);
        },
        connectionString(newval){
            this.updateelement('connectionString',newval);
        },
        initCommand(newval){
            this.updateelement('initCommand',newval);
        },
        schemaName(newval){
            this.updateelement('schemaName',newval);
        },
        description(newval) {
            this.updateelement('description',newval);
        },
    },

    methods: {

        reselected(value) {
           var that = this;
           that.selectedDriverSet=value;
           that.connectionString = defaultTemplates[value];
           that.selectedDriverSet=value;
        },
        
        updateelement(name, value)
        {
            if(this.selectedParameters)
            {
                var cnt = 0;
                for (cnt = 0; cnt < this.selectedParameters.length; cnt++)
                {
                    if(this.selectedParameters[cnt].name == name)
                    {
                        this.selectedParameters[cnt].value = value; 
                        break;
                    }
                }
                for (cnt = 0; cnt < this.realParametersConfigurations.length; cnt++)
                {
                    if(this.realParametersConfigurations[cnt].name == name)
                    {
                        this.realParametersConfigurations[cnt].value = value; 
                        break;
                    }
                }
                if(name == 'descripton')
                {
                    this.paramSets[0].description = value;
                }
            }
        },

        getData(name){
            if(this.selectedParameters)
            {
                var cnt = 0;
                for (cnt = 0; cnt < this.selectedParameters.length; cnt++)
                {
                    if(name == 'username')
                    {
                        if(this.selectedParameters[cnt].name == name)
                        {
                            this.username = this.selectedParameters[cnt].value; 
                            break;
                        }
                    }
                    if(name == 'password')
                    {
                        if(this.selectedParameters[cnt].name == name)
                        {
                            this.password = this.selectedParameters[cnt].value; 
                            break;
                        }
                    }
                    if(name == 'connectionString')
                    {
                        if(this.selectedParameters[cnt].name == name)
                        {
                            this.connectionString = this.selectedParameters[cnt].value; 
                            break;
                        }
                    }
                    if(name == 'initCommand')
                    {
                        if(this.selectedParameters[cnt].name == name)
                        {
                            this.initCommand = this.selectedParameters[cnt].value; 
                            break;
                        }
                    }
                    if(name == 'schemaName')
                    {
                        if(this.selectedParameters[cnt].name == name)
                        {
                            this.schemaName = this.selectedParameters[cnt].value; 
                            break;
                        }
                    }
                    if(name == 'description')
                    {
                        if(this.selectedParameters[cnt].name == name)
                        {
                            this.description = this.selectedParameters[cnt].value; 
                            break;
                        }
                    }
         
                }
            }
        },

        onGlobalAction(action) {
            if (action['callback']) {
                action.callback(action);
            }
        },

        addConnection(){
            this.showECMConnectionModal = true;
        },

        hint(){
            this.showRDBMSConnectionStrings=true;
        },

        setTemplate(info){
            this.connectionString = info; 
        },

        createEcmConnection(conDescr){
            var that = this;
            var descExists = false;
                        
            const len = that.paramSets.length;
            
            that.lastexistingindex++;
            
            var OneSet = [];
            
            for (var cnt = 0; cnt < that.fullPackage.length; cnt++)
            {
                const name  = that.fullPackage[cnt].name;
                
                if(name == 'description')
                {
                    that.realParametersConfigurations.push({"name" : that.fullPackage[cnt].name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": conDescr, "minValue" : that.fullPackage[cnt].minValue, "maxValue" :that.fullPackage[cnt].maxValue, "index": that.lastexistingindex});
                    OneSet.unshift({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : 1, "value": conDescr, "minValue" : that.fullPackage[cnt].minValue, "maxValue" :that.fullPackage[cnt].maxValue, "index": that.lastexistingindex });
                    descExists = true;
                }
                else
                {
                    that.realParametersConfigurations.push({"name" : that.fullPackage[cnt].name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "minValue" : that.fullPackage[cnt].minValue, "maxValue" :that.fullPackage[cnt].maxValue, "index": that.lastexistingindex});
                    OneSet.push({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "minValue" : that.fullPackage[cnt].minValue, "maxValue" :that.fullPackage[cnt].maxValue, "index": that.lastexistingindex });
                }
            }
            if(descExists == false)
            {
                that.realParametersConfigurations.push({"name" : "description", "type" : "string", "defaultvalue": "", "mandatory" : '0', "value": conDescr, "minValue" : '', "maxValue" :'', "index": that.lastexistingindex});
                OneSet.push({"name" : "description", "type" : "string", "defaultvalue": "", "mandatory" : "0", "value": conDescr, "minValue" : '', "maxValue" :'', "index": that.lastexistingindex });
          
            }            
            that.paramSets.push({"description":conDescr, "index":that.lastexistingindex, "setOfParameters":OneSet});
            
            if(that.paramSets.length > 0)
            {
                that.selectedSet=that.lastexistingindex;
                var cnt = 0;
                for (cnt = 0; cnt < that.paramSets.length; cnt++)
                {
                    if(that.paramSets[cnt].index == that.lastexistingindex)
                    {
                        that.selectedName=that.paramSets[cnt].description;    
                        that.selectedParameters = that.paramSets[cnt].setOfParameters;
                        break;
                    }
                }
                if(that.$refs.params_selector)
                    that.$refs.params_selector.refresh();
            }
        },

        deleteConnection(){
            var that = this;
            showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlDeleteConnection, that.ecmResourceStrings.txtDeleteConnection);
         },
        
        saveConfirmed()
        {         
            this.confirmationDlg = false;
            var that = this;
            const itemX=that.selectedSet;
            var cnt = 0;
            for (cnt = 0; cnt < that.paramSets.length; cnt++)
            {
                if(that.paramSets[cnt].index == itemX)
                {
                    const removed = that.paramSets.splice(cnt, 1);
                    break;
                }
            }

            if(that.paramSets.length > 0)
            {
                that.selectedSet=that.paramSets[0].index;
                that.selectedName=that.paramSets[0].description;
                that.selectedParameters = that.paramSets[0].setOfParameters;
                if(that.$refs.params_selector)
                    that.$refs.params_selector.refresh();  
            }
            else{
                that.selectedSet=0;
                that.selectedName='';
                that.selectedParameters=[];
            }
           
            //remove from real parameters
            cnt = 0;   
            for (cnt = that.realParametersConfigurations.length -1; cnt > -1; cnt--)
            {
                const index = that.realParametersConfigurations[cnt].index;
                if(index == itemX)   
                {
                    const removed = that.realParametersConfigurations.splice(cnt, 1);
                }
            }
        },

        /*reselected(value) {
            var that = this;
            that.selectedSet=value;
            for (var cnt = 0; cnt < that.paramSets.length; cnt++)
            {
                if(that.paramSets[cnt].index == value)
                {
                    that.selectedName=that.paramSets[cnt].description;    
                    that.selectedParameters = that.paramSets[cnt].setOfParameters;
                    that.getData('username');
                    that.getData('password');
                    that.getData('connectionString');
                    that.getData('initCommand');
                    that.getData('schemaName');
                    that.getData('description');
                    
                    return;
                }
            }
        },*/

        save(element) {
            //prevent old name just in case if for mandatory field value is empty 
            var that = this;
            var originalvalue='';
            var result = this.realParametersConfigurations.filter((el) => (el.name == element.name && el.index == element.index));
            if (result == undefined || result.length == 0)
            {
                //not found
            }
            else if (result.length == 1)
            {
                originalvalue = result[0].value;
            }

            const value = element.value;
            var configvalue = "";
            if(value.trim().length > 0)
            {
                configvalue = JSON.stringify(value); 
                //configvalue = configvalue.replace(/"/g, ""); 
                configvalue = configvalue.replace(/"/ , ""); 
                configvalue = configvalue.replace(/"$/,"");
            }
            else if(element.mandatory == 1/* && element.name == 'description'*/)
            {
                //can not be empty
                this.$snotify.clear();
                this.$snotify.error(this.ecmResourceStrings.txtErrorMandatory);
                element.value = originalvalue;
                return;
            }
            if (result[0])
            {
                //should be here
                result[0].value = element.value;
                //change description of package in set
                if(element.name == 'description')
                {
                    var cnt = 0;
                    for (cnt = 0; cnt < that.paramSets.length; cnt++)
                    {
                        if(that.paramSets[cnt].description == originalvalue)
                        {
                            that.paramSets[cnt].description = element.value; 
                            that.selectedName=that.paramSets[cnt].description;  
                            if(that.$refs.params_selector)
                                that.$refs.params_selector.refresh();

                            break;
                            /*it's automatically
                            var i = 0;
                            for (i = 0; i < that.paramSets[cnt].setOfParameters.length; i++)
                            {
                                if(that.paramSets[cnt].setOfParameters[i].name ==  == 'description')
                                    that.paramSets[cnt].setOfParameters[i].value=element.value;
                                break;
                            }
                            */
                        }
                    }
                }
                if(element.name == 'password')
                {
                    //we already saved value in real configuration. Just for UI replace it on "*****"
                    element.value='*****';
                }
            }
        },

        initParams : function()
        {   
            var that = this;
            that.fullPackage = [];//all mandatory + available together - one whole set (prototype of set) 
            that.paramSets = [];
           
            for (var cnt = 0; cnt < that.availableParametersConfigurations.length; cnt++)
            {
                if(that.availableParametersConfigurations[cnt].name == 'description')
                {
                    that.fullPackage.unshift({
                        "name" : that.availableParametersConfigurations[cnt].name,
                        "type" : that.availableParametersConfigurations[cnt].type, 
                        "defaultvalue": that.availableParametersConfigurations[cnt].defaultvalue, 
                        "mandatory" : that.availableParametersConfigurations[cnt].mandatory, 
                        "minValue" : that.availableParametersConfigurations[cnt].minValue,
                        "maxValue" : that.availableParametersConfigurations[cnt].maxValue,
                        "value": that.availableParametersConfigurations[cnt].value});         }
                else
                {
                    var spos = 0;
                    const found = that.availableParametersConfigurations.filter(function(item) { return item.name.toUpperCase() === 'hostname'.toUpperCase(); });
                    if(found.length > 0)
                    {
                        if(that.availableParametersConfigurations[cnt].name.toUpperCase() == 'username'.toUpperCase())
                        {
                            spos = 3;
                        }
                        if(that.availableParametersConfigurations[cnt].name.toUpperCase() == 'password'.toUpperCase())
                        {
                            spos = 4;
                        }
                    }
                    else
                    {
                        if(that.availableParametersConfigurations[cnt].name.toUpperCase() == 'username'.toUpperCase())
                        {
                            spos = 1;
                        }
                        if(that.availableParametersConfigurations[cnt].name.toUpperCase() == 'password'.toUpperCase())
                        {
                            spos = 2;
                        }
                    }
                    if(spos == 0)
                    {
                        that.fullPackage.push({
                            "name" : that.availableParametersConfigurations[cnt].name,
                            "type" : that.availableParametersConfigurations[cnt].type, 
                            "defaultvalue": that.availableParametersConfigurations[cnt].defaultvalue, 
                            "mandatory" : that.availableParametersConfigurations[cnt].mandatory, 
                            "minValue" : that.availableParametersConfigurations[cnt].minValue,
                            "maxValue" : that.availableParametersConfigurations[cnt].maxValue,
                            "value": that.availableParametersConfigurations[cnt].value});
                    }
                    else
                    {
                        that.fullPackage.splice(spos, 0, {
                            "name" : that.availableParametersConfigurations[cnt].name,
                            "type" : that.availableParametersConfigurations[cnt].type, 
                            "defaultvalue": that.availableParametersConfigurations[cnt].defaultvalue, 
                            "mandatory" : that.availableParametersConfigurations[cnt].mandatory, 
                            "minValue" : that.availableParametersConfigurations[cnt].minValue,
                            "maxValue" : that.availableParametersConfigurations[cnt].maxValue,
                            "value": that.availableParametersConfigurations[cnt].value});
                    }
                }
            }
            var startindex = -1;
            var lastindex = -1;
            var OneSet = [];
            var descr = '';
            var index = -1;
            if(that.realParametersConfigurations.length == 0)
            {
                that.createEcmConnection('RDBMS');
            }
            else
            {
                for (var cnt = 0; cnt < that.realParametersConfigurations.length; cnt++)
                {
                    const name = that.realParametersConfigurations[cnt].name;
                    if(startindex == -1)
                    {
                        startindex = 0;
                    }
                    lastindex = that.realParametersConfigurations[cnt].index;
                    if(that.realParametersConfigurations[cnt].index == startindex)
                    {
                        if(name == 'description')
                        {
                            descr = that.realParametersConfigurations[cnt].value;
                            index = that.realParametersConfigurations[cnt].index;
                            OneSet.unshift({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realParametersConfigurations[cnt].value, "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                        }
                        else
                        {
                            if(name == 'password' && that.realParametersConfigurations[cnt].value != '' && that.realParametersConfigurations[cnt].value != '*****')
                            {
                                OneSet.push({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : that.realParametersConfigurations[cnt].mandatory, "value": '*****', "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                            }
                            else
                            {
                                if(name == 'connectionString')
                                {
                                    //parse
                                    var fullvalue = that.realParametersConfigurations[cnt].value;
                                    var tst = fullvalue.split(';');
                                    var k = 0;
                                    for(k=0; k<tst.length;k++)
                                    {
                                        var fullline = tst[k];
                                        var parts = fullvalue.split('=');
                                        var ty = 0;
                                        if(parts.length>0)
                                        {
                                        
                                            var partone = parts[0];
                                            if(partone.toUpperCase() == "DRIVER")
                                            {
                                                var parttwo = parts[1];
                                                var str= parttwo.toUpperCase();
                                                var n = str.search("POSTGRESQL");
                                                if(n > -1)
                                                {
                                                    that.selectedDriverSet='1';
                                                }
                                                else
                                                {
                                                    n = str.search("SQL");
                                                    if(n > -1)
                                                    {
                                                        that.selectedDriverSet='2';
                                                    }
                                                    else
                                                    {
                                                        n = str.search("ORACLE");
                                                        if(n > -1)
                                                        {
                                                            that.selectedDriverSet='3';
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    OneSet.push({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : that.realParametersConfigurations[cnt].mandatory, "value": that.realParametersConfigurations[cnt].value, "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                                }
                                else
                                {
                                    OneSet.push({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : that.realParametersConfigurations[cnt].mandatory, "value": that.realParametersConfigurations[cnt].value, "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                                }
                            }
                        }
                    }
                    else
                    {
                        //index was changed

                        that.paramSets.push({"description":descr, "index":index, "setOfParameters":OneSet});
                        startindex = that.realParametersConfigurations[cnt].index;
                        OneSet = [];
                        if(name == 'description')
                        {
                            descr = that.realParametersConfigurations[cnt].value;
                            index = that.realParametersConfigurations[cnt].index;
                            OneSet.unshift({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realParametersConfigurations[cnt].value, "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                        }
                        else
                        {
                            if(name == 'connectionString')
                                {
                                    //parse
                                    var fullvalue = that.realParametersConfigurations[cnt].value;
                                    var tst = fullvalue.split(';');
                                    
                                }
                                else
                                {
                                    OneSet.push({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : that.realParametersConfigurations[cnt].mandatory, "value": that.realParametersConfigurations[cnt].value, "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                                }
                       } 
                    }
                }
            }
            
            if(lastindex != -1 && lastindex == startindex) //the last one
            {
                 that.paramSets.push({"description":descr, "index":index, "setOfParameters":OneSet});
            }
            if(that.paramSets.length > 0)
            {
                that.selectedSet=0;
                that.selectedName=that.paramSets[0].description;
                that.selectedParameters = that.paramSets[0].setOfParameters;
                that.getData('username');
                that.getData('password');
                that.getData('connectionString');
                that.getData('initCommand');
                that.getData('schemaName');
                that.getData('description');
                
            }
            that.lastexistingindex = lastindex;
        },
        
    },
  
    mounted() {

            var breadcrumbs = [{
                name: 'settings',
                meta: { label: 'Settings' }
            },        {
                name: 'ecm-repositories',
                meta: { label: 'Repositories' }
            },{
                name: 'ecm-repo',
                meta: { label: 'Update ECM Repository' }
            }];
            this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        that.initParams();
        that.loaded = true;
    },
}
</script>